import React from 'react';
import { motion } from 'framer-motion';
export function EnvironmentsSection() {
  const environments = [{
    icon: '🏥',
    text: 'Consultorio Privado'
  }, {
    icon: '🏨',
    text: 'Hospitales Generales y Psiquiátricos'
  }, {
    icon: '🧠',
    text: 'Centros de Salud Mental'
  }, {
    icon: '💊',
    text: 'Clínicas de Rehabilitación y Adicciones'
  }, {
    icon: '🏠',
    text: 'Atención Domiciliaria'
  }, {
    icon: '📋',
    text: 'Obras Sociales y Prepagas'
  }, {
    icon: '⚖️',
    text: 'Pericias y Actuaciones Judiciales'
  }];
  return <section className="py-20 bg-navy" data-id="element-44">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-45">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-serif font-bold text-white mb-12" data-id="element-46">
          Utilizado en todo tipo de entornos psiquiátricos
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 justify-center" data-id="element-47">
          {environments.map((env, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className={`glass-panel rounded-xl p-4 flex items-center space-x-4 hover:border-gold/50 transition-colors ${index === environments.length - 1 ? 'sm:col-span-2 md:col-span-1 md:col-start-2' : ''}`} data-id="element-48">
              <span className="text-3xl" data-id="element-49">{env.icon}</span>
              <span className="text-left font-medium text-gray-200" data-id="element-50">
                {env.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}